export const KPI_TACHO = ({ processedDashboardData, targetTachoCompliance, superRestricted, isTachoAllowed, handleChangeTab, theme }) => {
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '25px',
            borderRadius: '15px',
            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden',
            cursor: (!superRestricted && isTachoAllowed) ? 'pointer' : 'default'
        }}
        onClick={(!superRestricted && isTachoAllowed) ? () => handleChangeTab('tacho') : null}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? '#28a745' : 
                            (processedDashboardData?.tachoKpis?.unsigned || 0) <= (targetTachoCompliance + 3) ? '#ffc107' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 8px 0', letterSpacing: '0.5px' }}>
                        TACHO COMPLIANCE
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? '#28a745' : 
                                    (processedDashboardData?.tachoKpis?.unsigned || 0) <= (targetTachoCompliance + 3) ? '#ffc107' : '#dc3545',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData?.tachoKpis?.unsigned || 0}
                        </span>
                        <span style={{
                            fontSize: '18px',
                            color: (processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? '#28a745' : 
                                    (processedDashboardData?.tachoKpis?.unsigned || 0) <= (targetTachoCompliance + 3) ? '#ffc107' : '#dc3545',
                            fontWeight: '500'
                        }}>
                            {(processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? '✓' : '⚠'}
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? 'rgba(40, 167, 69, 0.1)' : 
                                (processedDashboardData?.tachoKpis?.unsigned || 0) <= (targetTachoCompliance + 3) ? 'rgba(255, 193, 7, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '12px',
                    borderRadius: '10px',
                    fontSize: '24px'
                }}>
                    📊
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '8px',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span>Total (28 days): {processedDashboardData?.tachoKpis?.total || 0}</span>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: (processedDashboardData?.tachoKpis?.critical || 0) > 0 ? '#dc3545' : theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px',
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <span>Critical: {processedDashboardData?.tachoKpis?.critical || 0}</span>
                <span>Unresolved: {processedDashboardData?.tachoKpis?.unresolved || 0}</span>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? '#28a745' : 
                        (processedDashboardData?.tachoKpis?.unsigned || 0) <= (targetTachoCompliance + 3) ? '#ffc107' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: {targetTachoCompliance} Unsigned • {(processedDashboardData?.tachoKpis?.unsigned || 0) <= targetTachoCompliance ? 'COMPLIANT' : 'ACTION REQUIRED'} • 28-Day Rolling
            </div>
        </div>
    )
}